module.exports = __webpack_public_path__ + "media/images/sales/set/eyecatch-set-01-summmer-c9f28ac0b6bb04305f6434ae437f3747.svg";